import { Container } from 'flux/utils';

export const withStore = (Component) => Container.create(Component);

export const withStoreConfigured = (settings) => (Component) => Container.create(Component, settings);
